/**
 * @desc 红人领用管理-导出
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.kol.useCelebrity.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/useCelebrity/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
